<form [formGroup]="formGroup"
      (ngSubmit)="onFormSubmit($event)">
    <mat-form-field>
        <mat-label>{{ 'changePassword.currentPassword' | translate }}</mat-label>
        <input matInput
               type="password"
               required
               formControlName="currentPassword">
        @if (formGroup?.controls?.currentPassword?.errors) {
            <mat-error>
                <!--
                Rxwebvalidators `required` message is overridden by Angular Material `required` message.
                If we want to use Rxwebvalidators `required` message, we can get rid of `required` attribute in matInput control.
                However, that will remove the auto-asterisk feature provided by Angular Material MatInput.
                 -->
                @if (formGroup.controls.currentPassword.errors.required) {
                    {{ 'passwordValidation.passwordRequired' | translate }}
                }
            </mat-error>
        }
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{ 'changePassword.newPassword' | translate }}</mat-label>
        <input matInput
               type="password"
               required
               (focusin)="validation.hidden = false"
               (focusout)="validation.hidden = true"
               formControlName="newPassword">
        <span class="validation-message" hidden #validation>
            <span class="heading">{{ 'resetPassword.passwordRequirements.title' | translate }}</span>
            <ul>
                <li>{{ 'resetPassword.passwordRequirements.alphabet' | translate }}</li>
                <li>{{ 'resetPassword.passwordRequirements.number' | translate }}</li>
                <li>{{ 'resetPassword.passwordRequirements.length' | translate:{ minLength: APP_CONFIG.minPasswordLength } }}</li>
                <li>{{ 'resetPassword.passwordRequirements.noBlank' | translate }}</li>
            </ul>
        </span>

        @if (formGroup?.controls?.newPassword?.errors) {
            <mat-error>
                @if (formGroup.controls.newPassword.errors.required) {
                    {{ 'passwordValidation.passwordRequired' | translate }}
                }

                {{ formGroup.controls.newPassword.errors.password?.message }}
            </mat-error>
        }
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{ 'changePassword.confirmNewPassword' | translate }}</mat-label>
        <input matInput
               type="password"
               required
               formControlName="confirmNewPassword">
        @if (formGroup?.controls?.confirmNewPassword?.errors) {
            <mat-error>
                @if (formGroup.controls.confirmNewPassword.errors.required) {
                    {{ 'passwordValidation.passwordRequired' | translate }}
                }

                {{ formGroup.controls.confirmNewPassword.errors.compare?.message }}
            </mat-error>
        }
    </mat-form-field>

    <div class="actions">
        <button mat-flat-button
                class="action"
                type="submit"
                color="primary"
                *spinOn="isFormSubmitting"
                [disabled]="!formGroup.valid">{{ 'changePassword.submit' | translate }}
        </button>
    </div>
</form>
